<template>

  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
  >
    <template #create-button>
      <b-button
        v-if="canCreate()"
        v-b-toggle.sidebar-create-quote-agreement
        variant="primary"
        @click="created"
      >
        {{ $t('Create') }}
      </b-button>
    </template>
    <template #create-body>
      <create
        ref="createQuoteAgreement"
        @refetchData="refetchData"
      />
      <accept-or-reject
        ref="acceptOrReject"
        @refetchData="refetchData"
      />
    </template>
    <template #cell(period)="{ data }">
      {{ data.value.admission_year }}
    </template>

    <template #cell(status)="{data}">
      <b-badge :variant="getStatus(data.value).color">
        {{ $langName(getStatus(data.value).name) }}
      </b-badge>
    </template>

    <template #cell(org)="{ data }">
      {{ $langName(data.value.name) }}
    </template>
    <template #cell(file)="{ data }">
      <b-link
        :href="data.value"
        download="file"
        target="_blank"
      >
        <feather-icon
          icon="DownloadIcon"
          class="mr-50"
        />

      </b-link>
    </template>

    <!-- Column: Actions -->
    <template #cell(actions)="{ data }">

      <div class="text-nowrap">

        <feather-icon
          v-if="canUpdate(data.item)"
          v-b-toggle.sidebar-accept-or-reject-quote-agreement
          icon="EditIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="update(data.item)"
        />
        <feather-icon
          v-if="canDelete(data.item)"
          icon="TrashIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="remove(data.item)"
        />
      </div>
    </template>
  </l-table>
</template>

<script>
import {
  BBadge,
  BButton, BLink, VBToggle,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import config from './config'
import quoteAgreementModule from '@/store/quote-agreement/index'
import Create from './Create.vue'
import permission from './permission'
import LTable from '@/views/components/LTable.vue'
import AcceptOrReject from '@/views/pages/quote-agreement/AcceptOrReject.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BLink,
    BBadge,
    AcceptOrReject,
    LTable,
    BButton,
    Create,
  },
  created() {
    this.$store.commit(`${this.MODULE_NAME}/FRESH`)
    this.$store.dispatch('staticModule/periodList', { limit: 9999 })
    this.$store.dispatch('staticModule/organizationList', { type_org_id: store.state.staticModule.orgTypeMinistry })
  },
  methods: {
    update(data) {
      this.$store.commit(`${this.MODULE_NAME}/UPDATE`, data)
    },
    created() {
      this.$store.commit(`${this.MODULE_NAME}/FRESH`)
    },
    refetchData() {
      this.$refs.LTable.refetchData()
    },
    getStatus(statusCode) {
      return this.$store.getters['staticModule/getQuoteAgreementStatus'](statusCode)
    },
    remove(data) {
      this.$removeSwal(this, data, `${this.MODULE_NAME}/del`, this.refetchData)
    },
  },
  setup() {
    const MODULE_NAME = 'quoteAgreement'

    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, quoteAgreementModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })

    return {
      ...config(),
      MODULE_NAME,
      ...permission(),
    }
  },
}
</script>
